/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * NUMBER_TICKET : the number ticket
 *   * CREATION_DATE : the ticket creation date
 *   * LAST_UPDATE : the ticket last update date
 *   * STATION_NAME : the station name
 *   * TYPE_PANNE : type panne
 *   * STATE : the state
 */
export enum TicketSortFieldName {
  NUMBER_TICKET = 'NUMBER_TICKET',
  CREATION_DATE = 'CREATION_DATE',
  LAST_UPDATE = 'LAST_UPDATE',
  STATION_NAME = 'STATION_NAME',
  TYPE_PANNE = 'TYPE_PANNE',
  STATE = 'STATE'
}
